
<h2 mat-dialog-title>{{'pass.widgets.filter.comparisson' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      <form [formGroup]="filterForm">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'content.key' | translate}}</mat-label>
          <input formControlName="field" type="text" matInput placeholder="{{'content.key' | translate}}">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.widgets.filter.operator' | translate}}</mat-label>
          <mat-select formControlName="operator">
            <!-- <mat-option value=""> - </mat-option> -->
            @for (operator of filterOperatorTypes; track operator) {
              <mat-option [value]="operator.type">{{ operator.translate | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.widgets.filter.value' | translate}}</mat-label>
          <input formControlName="value" type="text" matInput placeholder="{{'pass.widgets.filter.value' | translate}}">
        </mat-form-field>

      </form>
    </section>
  </div>


</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel();" > {{'cancel' | translate}} </button>
  <button mat-button class="orange-button" (click)="onSave();" [disabled]="filterForm.invalid">{{'apply' | translate}}</button>
</mat-dialog-actions>
